import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Autocomplete, AutocompleteProps, Box, Grid, /* Link, */ TextField, Tooltip, Typography } from '@mui/material';
import { Settings } from '@mui/icons-material';
import { Loading } from 'components';

type OptionsConfig = {
  icon: any;
  description: string;
  linkLabel: string;
  link: string;
};

export type BasicSelectorProps = {
  options?: any[];
  label?: string;
  placeholder?: string;
  error?: boolean;
  helperText?: string;
  optionsLoadingText?: string;
  optionsConfig?: Partial<OptionsConfig> | false;
} & Partial<AutocompleteProps<any, any, any, any>>;

export const BasicSelector = ({
  options = [],
  label = 'Select option...',
  placeholder = '',
  error = false,
  helperText = '',
  optionsLoadingText = 'Loading options...',
  optionsConfig: _optionsConfig = {},
  ...restProps
}: BasicSelectorProps) => {
  const navigate = useNavigate();

  const defaultOptionsConfig: OptionsConfig = {
    icon: (
      <Settings
        color="primary"
        sx={{ cursor: 'pointer' }}
        onClick={() => {
          if (optionsConfig) {
            navigate(optionsConfig.link);
          }
        }}
      />
    ),
    description: 'The list options can be customized.',
    linkLabel: 'Go to edit options',
    link: '',
  };

  const optionsConfig = _optionsConfig === false ? false : { ...defaultOptionsConfig, ..._optionsConfig };

  return (
    <Grid container spacing={2}>
      <Grid item sx={{ flex: 1 }}>
        <Autocomplete
          disablePortal
          options={options}
          renderInput={(params) => (
            <TextField {...params} label={label} placeholder={placeholder} error={error} helperText={helperText} />
          )}
          loadingText={<Loading text={optionsLoadingText} height={120} />}
          {...restProps}
        />
      </Grid>

      {optionsConfig && (
        <Grid item>
          <Tooltip
            title={
              <Box sx={{ padding: 0.5 }}>
                <Typography variant="body2" gutterBottom>
                  {optionsConfig.description}
                </Typography>

                {/* <Link component="button" variant="body2" onClick={() => navigate(optionsConfig.link)}>
                  {optionsConfig.linkLabel}
                </Link> */}
              </Box>
            }
            arrow
            placement="top"
          >
            <Box sx={{ marginTop: 2 }}>{optionsConfig.icon}</Box>
          </Tooltip>
        </Grid>
      )}
    </Grid>
  );
};
